<ul class="eb-generic-page-stepper__list">
  <li
    *ngFor="let step of steps; let i = index"
    class="eb-generic-page-stepper__item"
    [class.active]="isActive(i)"
    [class.disabled]="isDisabled(i)"
  >
    <cx-icon
      *ngIf="i !== 0"
      [type]="IconType.CARET_RIGHT"
      class="eb-generic-page-stepper__caret"
    ></cx-icon>
    <a
      [routerLink]="{ cxRoute: step.routeName } | cxUrl"
      class="eb-generic-page-stepper__link"
      [tabindex]="getTabIndex(i)"
      [innerHTML]="i + 1 + '. ' + (step.name | cxTranslate)"
      (click)="changeStep.emit(i)"
    >
      {{ i + 1 }}.
    </a>
  </li>
</ul>
